<template>
  <Modal
    ref="modal"
    :beforeCloseModal="beforeCloseModal"
    :afterOpenModal="afterOpenModal"
    :beforeOpenModal="beforeOpenModal"
    :afterCloseModal="afterCloseModal"
    class="insurance_not_cover"
  >
    <p class="insurance-not-cover-hint">{{ hint }}</p>
    <div slot="btns">
      <button
        type="button"
        class="btn btn--darkblue"
        @click="cancelBtn"
      >{{ $t('action.cancel') }}</button>
      <button
        type="button"
        class="btn btn--orange"
        @click="continueBtn"
      >{{ $t('action.continue') }}</button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/controls/Modal'
export default {
  name: 'InsuranceNotCoverModal',
  components: {
    Modal,
  },
  props: {
    hint: {
      type: String,
    },
    beforeOpenModal: {
      type: Function,
      default: () => { return true },
    },
    afterOpenModal: {
      type: Function,
      default: () => {},
    },
    beforeCloseModal: {
      type: Function,
      default: () => {},
    },
    afterCloseModal: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      isOpen: false,
    }
  },
  computed: {
    modal () {
      return this.$refs.modal
    },
    buttonDisabled () {
      return !this.value
    },
  },
  methods: {
    cancelBtn () {
      this.$emit('cancelEvent')
    },
    continueBtn () {
      this.$emit('continueEvent')
    },
    open () {
      this.isOpen = true
      return this.modal.open()
    },
    close () {
      this.isOpen = false
      return this.modal.close()
    },
  },
}
</script>

<style lang="scss" scoped>
  .action-confirm-title {
    font-size: 14px;
    font-weight: bold;
    color: #0c3a58;
  }
  .insurance_not_cover {
    .insurance-not-cover-hint {
      font-weight: bold;
    }
  }
</style>
